var head = document.getElementsByTagName('head')[0];
/* 
    renderTo: 容器元素id
    outerThis: 调用该方法的react组件实例(用来绑定resetCaptcha方法)
    callback: 将sig,token,sessionId注入react组件state
*/
function captcha (option) {
    var renderTo = option.renderTo;
    var width = option.width || '100%';
    var height = option.height || 42;
    var scene = option.scene || 'ic_login';
    var isH5 = option.isH5 !== undefined ? option.isH5 : false;
    var callback = option.callback;
    var outerThis = option.outerThis;

    if (!callback || !renderTo || !outerThis) {
        throw new Error('` option.callback and option.renderTo, option.outerThis is required`');
    };

    require('./style.less');

    renderTo = '#' + renderTo;

    var ic = null;
    // 初始化NVC_Opt
    init_NVC_opt({ scene, renderTo});

    if (!window.smartCaptcha || !window.getNVCVal) {
        appendScript(init);
    } else {
        init()
    };
    function init() {
        if (ic) {
            return;
        };
        ic = new smartCaptcha({
            renderTo: renderTo,
            width: width,
            secvrf_layout: isH5,
            height: height,
            default_txt: "点击按钮验证",
            success_txt: "验证通过",
            fail_txt: "验证失败，请点击按钮刷新",
            scaning_txt: "正在验证",
            success: function(data) {
                callback({
                    sessionId: data.sessionId,
                    token: NVC_Opt.token,
                    sig: data.sig
                });
            }
        });
        ic.init();
        // 给外部调用者重置状态
        outerThis.resetCaptcha = ic.reset.bind(ic);
    };  
};

function init_NVC_opt({ scene, renderTo }) {
    window.NVC_Opt = {
        appkey: window._aliyun_afs_app_key,
        scene: scene,
        renderTo: renderTo,
        obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
        obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
        bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
        bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
        upLang:{"cn":{
            _ggk_guide: "请摁住鼠标左键，刮出两面盾牌",
            _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
            _ggk_loading: "加载中",
            _ggk_fail: ["呀，盾牌不见了<br/>请","javascript:noCaptcha.reset()","再来一次","或","http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"],
            _ggk_action_timeout: ["我等得太久啦<br/>请","javascript:noCaptcha.reset()","再来一次","或","http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"],
            _ggk_net_err: ["网络实在不给力<br/>请","javascript:noCaptcha.reset()","再来一次","或","http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"],
            _ggk_too_fast: ["您刮得太快啦<br/>请","javascript:noCaptcha.reset()","再来一次","或","http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN","反馈问题"]
            }
        },
        elements: [
            "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png",
            "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png"
        ], 
        bg_back_prepared: "//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png",
        bg_front: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC"
    };
};

function appendScript(callback) {
    var script4Guide = document.createElement('script');
    var script4smartCaptcha = document.createElement('script');
    var script4quiz = document.createElement('script');
    script4smartCaptcha.src = '//g.alicdn.com/sd/smartCaptcha/0.0.4/index.js';
    script4Guide.src = '//g.alicdn.com/sd/nvc/1.1.112/guide.js' ;
    script4quiz.src = '//g.alicdn.com/sd/quizCaptcha/0.0.1/index.js';
    var scriptArray = [script4Guide, script4smartCaptcha, script4quiz];
    var loadCount = 0;
    function load() {
        loadCount += 1;
        var arr = [];
        if (loadCount === 3 || arr.length === 3) {
            callback();
        };
    }
    head.appendChild(script4Guide);
    head.appendChild(script4quiz);
    head.appendChild(script4smartCaptcha);
    for (var l = 0; l < 3; l ++) {
        var i = scriptArray[l];
        if (i.readyState) {
            i.onreadystatechange = () => {
                var readyState = i.readyState;
                if (readyState =='complete' || readyState=='loaded') {
                    load();
                };
            };
        } else {
            i.onload = load;
        };
    };
};

export default captcha;



// WEBPACK FOOTER //
// ./src/captcha/captcha.jsx